import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { PersonaEligibilityComponent } from './persona-eligibility/persona-eligibility.component'

@NgModule({
  imports: [CommonModule, SeFeTranslationsModule],
  declarations: [PersonaEligibilityComponent],
  exports: [PersonaEligibilityComponent],
})
export class SharedUiPersonaEligibilityModule {}
